import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { Cliente } from '../../../core/model/cliente';
import { DepartamentoSerie } from '../../../core/model/departamento-serie';
import { FileData, MassiveLoadExcelField, MassiveLoadResult } from '../../../core/model/massive-load-result';
import { Page } from '../../../core/model/page';
import { Template } from '../../../core/model/template';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { CargaMasivaService } from '../../../core/services/carga-masiva.service';
import { ClientesService } from '../../../core/services/clientes.service';
import { DepartamentosSeriesService } from '../../../core/services/departamentos-series.service';
import { InventariosService } from '../../../core/services/inventarios.service';
import { TemplatesService } from '../../../core/services/templates.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { CargaMasivaComponent } from '../../carga-masiva/carga-masiva.component';

@Component({
  selector: 'app-nueva-carga',
  templateUrl: './nueva-carga.component.html',
  styleUrls: ['./nueva-carga.component.css']
})
export class NuevaCargaComponent implements OnInit {

  clientes: Cliente[];
  series: DepartamentoSerie[];
  loading = false;
  isDocout = false;

  plantilla: any;

  plantillaInventario = 0;

  clienteSeleccionado: any = undefined;
  serieSeleccionada: any = undefined;

  ficheroCarga: FileData;

  contenidosSeleccionados: MassiveLoadExcelField[][];
  page = new Page();
  vistaTabla: any;

  @Output() reloadTablaCargas = new EventEmitter<any>();

  @ViewChild('tblContenidos') table: any;

  constructor(
    private clientesService: ClientesService,
    private toastr: ToastrService,
    private deparamentosSeriesService: DepartamentosSeriesService,
    private authService: AuthenticationService,
    private cargaMasivaService: CargaMasivaService,
    private utilsService: UtilitiesService,
    private templateService: TemplatesService,
    private modalservice: BsModalService,
    private inventoryService: InventariosService
  ) { }

  ngOnInit() {
    this.load();
    this.authService.isDocOutUser()
      .then(
        p => this.isDocout = p.valueOf()
      )
      .catch(
        _ => this.toastr.error('No se ha podido determinar la identidad del usuario')
      );
  }

  resetAll() {
    this.clientes = undefined;
    this.clienteSeleccionado = undefined;
    this.series = undefined;
    this.serieSeleccionada = undefined;
    this.ficheroCarga = undefined;
    this.contenidosSeleccionados = undefined;
    this.vistaTabla = undefined;
    this.plantillaInventario = 0;
    this.plantilla = undefined;
    this.load();
  }

  resetPagination() {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  setPage($event) {
    this.page.pageNumber = $event.offset;
    this.movePageTabla();
  }

  onResized($event) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  movePageTabla() {
    this.vistaTabla = this.contenidosSeleccionados.slice(this.page.pageNumber * this.page.size, (this.page.pageNumber + 1) * this.page.size);
  }

  showModalCargaMasiva() {
    const modalRef = this.modalservice
      .show(CargaMasivaComponent,
        {
          class: 'modal-dialog modal-lg',
          initialState: { templateId: this.plantillaInventario, autoLoad: false, showConfirmationModal: false }
        });
    (<CargaMasivaComponent>modalRef.content).onClose.subscribe((result: MassiveLoadResult) => {
      if (result) {
        this.loading = true;
        this.templateService.getTemplateInventarioSerie(this.serieSeleccionada)
          .subscribe(
            (p) => {
              this.loading = false;
              this.plantilla = p;
            },
            () => {
              this.loading = false;
              this.toastr.error('Ha ocurrido un error al recuperar la plantilla del inventario');
            });
        this.contenidosSeleccionados = result.registrosExcel;
        this.movePageTabla();
      }
    }, error => {
      this.toastr.error('No ha sido posible realizar la operación. Por favor, inténtelo de nuevo más tarde.');
    });
    (<CargaMasivaComponent>modalRef.content).onFileUploaded.pipe(first()).subscribe((fileData: FileData) => {
      if (fileData) {
        this.ficheroCarga = fileData;
      }
    });
  }

  cargarNuevaCargaInventario() {
    this.loading = true;
    this.inventoryService.loadNewCargaInventario(false, '', this.ficheroCarga)
      .subscribe(
        p => {
          if (p.isOk) {
            this.toastr.success('Se ha añadido correctamente en cola. Numero de registros: ' + p.numeroRegistros)
          } else {
            this.toastr.error('Ha ocurrido un error al añadir el fichero de la carga');
          }
          this.loading = false;
          this.reloadTablaCargas.emit();
          this.resetAll();
        },
        () => this.toastr.error('Ha ocurrido un error al tratar de cargar el fichero en la batch. Vuelva a intentarlo' +
          'pasados unos segundos o póngase en contacto con soporte'));
  }

  load() {
    this.loading = true;
    this.clientesService.getAllClientes(true)
      .subscribe(
        (p) => {
          this.clientes = p.sort(function (a, b) {
            const nameA = a.NOMBRE.toLowerCase(), nameB = b.NOMBRE.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          if (p.length === 1) {
            this.clienteSeleccionado = p[0].ID;
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al recuperar los clientes');
        });
    this.resetPagination();
  }

  cargarSeriesCliente(idCliente: number) {
    this.reset();
    this.loading = true;
    this.deparamentosSeriesService.getDepartamentosSeriesByClient(idCliente, null, true)
      .subscribe(
        (p) => {
          this.series = p;
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al recuperar las series documentales del cliente');
        });
  }

  descargarPlantilla() {
    this.cargaMasivaService.getEmptyTemplateFile(this.plantillaInventario)
      .subscribe(
        (p) => {
          this.utilsService.downloadGenericFile('plantillaInventarios' + this.plantillaInventario + '.xlsx', p);
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al descargar la plantilla de inventarios de la serie seleccionada.' +
            ' Vuelva a intentarlo pasados unos minutos o pongase en contacto con su administrador o con soporte');
        });
  }

  reset() {
    this.ficheroCarga = undefined;
    this.vistaTabla = undefined;
    this.contenidosSeleccionados = undefined;
  }

  comprobarPlantillaInventario() {
    this.reset();
    if (this.serieSeleccionada === '-1') {
      return;
    }
    this.loading = true;
    this.templateService.getIdPlantillaInventario(this.serieSeleccionada)
      .subscribe(
        (p) => {
          this.plantillaInventario = p;
          if (p === 0) {
            this.toastr.warning('La serie seleccionada no tiene asignada una plantilla de inventario. Pongase en contacto con su administrador o con soporte');
          } else {
            this.showModalCargaMasiva();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al recuperar la plantilla de inventario de la serie selccionada.' +
            ' Vuelva a intentarlo pasados unos seungods o pongase en contacto con su administrador o soporte');
        }
      );
  }

  dameValor(fila, columna) {
    if (fila.filter(f => f.nombreCampo === columna).length > 0) {
      return fila.filter(f => f.nombreCampo === columna)[0].valor;
    }
    return null;
  }

}
